<template>
	<el-container class="wrap-80">
		<InfoLeftSide v-if="group != '在线问题反馈' && group != '操作说明'" ref="LeftSideDom" :group="group" :menus="menus" @setSelectInfo="setSelectInfo"></InfoLeftSide>

		<!-- <InfoContent v-if="type == 'content'" :info="info"></InfoContent> -->
		<div v-if="type == 'content'">
			<div v-if="curRouteName == '量大信息研究院（平台运营）'">
				<ACon></ACon>
			</div>

			<div v-if="curRouteName == '品读文化（图书销售）'">
				<BCon></BCon>
			</div>

			<div v-if="curRouteName == '用户协议'">
				<CCon></CCon>
			</div>

			<div v-if="curRouteName == '隐私协议'">
				<DCon></DCon>
			</div>

			<div v-if="curRouteName == '图书销售协议'">
				<LCon></LCon>
			</div>

			<div v-if="curRouteName == '社区规则'">
				<ECon></ECon>
			</div>
			<div v-if="curRouteName == 'AI-行业大模型' && group == '功能介绍'">
				<FCon></FCon>
			</div>
			<div v-if="curRouteName == 'AI-行业大模型' && group == '功能介绍_个人版'">
				<PAICon></PAICon>
			</div>
			<div v-if="curRouteName == '法规标准库' && group == '功能介绍'">
				<GCon></GCon>
			</div>
			<div v-if="curRouteName == '法规标准库' && group == '功能介绍_个人版'">
				<PRegCon></PRegCon>
			</div>
			<div v-if="curRouteName == '行业数据库'">
				<HCon></HCon>
			</div>
			<div v-if="curRouteName == '社区'">
				<ICon></ICon>
			</div>
			<div v-if="curRouteName == '企业资料馆'">
				<JCon></JCon>
			</div>
			<div v-if="curRouteName == '个人书架'">
				<PBookShelfCon></PBookShelfCon>
			</div>
			<div v-if="curRouteName == '正版图书购买' && group == '功能介绍'">
				<KCon></KCon>
			</div>
			<div v-if="curRouteName == '正版图书购买' && group == '功能介绍_个人版'">
				<PBookStoreCon></PBookStoreCon>
			</div>
			<div v-if="curRouteName == '网上书城'">
				<PBookStoreCon></PBookStoreCon>
			</div>
		</div>
		<div v-else style="flex: 1">
			<Feedback></Feedback>
		</div>
	</el-container>
</template>

<script>
import InfoLeftSide from '@/components/InfoLeftSide';
import InfoContent from '@/components/InfoContent';
import Feedback from '@/components/FeedBack';
import AgreeList from '@/data/agree';
import ProductList from '@/data/product';
import PersonProductList from '@/data/personProduct';
import AboutUsList from '@/data/about';
import LoginList from '@/data/login';
import ACon from '@/components/InfoContent/1.vue';
import BCon from '@/components/InfoContent/2.vue';
import CCon from '@/components/InfoContent/11.vue';
import DCon from '@/components/InfoContent/12.vue';
import ECon from '@/components/InfoContent/13.vue';
import FCon from '@/components/InfoContent/101.vue';
import GCon from '@/components/InfoContent/102.vue';
import HCon from '@/components/InfoContent/103.vue';
import ICon from '@/components/InfoContent/104.vue';
import JCon from '@/components/InfoContent/105.vue';
import KCon from '@/components/InfoContent/106.vue';
import LCon from '@/components/InfoContent/14.vue';
import PAICon from '@/components/InfoContent/201.vue';
import PRegCon from '@/components/InfoContent/202.vue';
import PBookShelfCon from '@/components/InfoContent/205.vue';
import PBookStoreCon from '@/components/InfoContent/206.vue';

export default {
	data() {
		return {
			group: '用户协议',
			menus: [],
			info: {},
			type: 'content'
		};
	},
	components: {
		InfoLeftSide,
		InfoContent,
		Feedback,
		ACon,
		BCon,
		CCon,
		DCon,
		ECon,
		FCon,
		GCon,
		HCon,
		ICon,
		JCon,
		KCon,
		LCon,
		PAICon,
		PRegCon,
		PBookShelfCon,
		PBookStoreCon
	},
	computed: {
		curRouteName() {
			// console.log('this.$route.query.title', this.$route.query.title);
			return this.$route.query.title;
		}
	},
	methods: {
		setSEOInfo(group) {
			const meta = `${group}（${this.$route.query.title}）`;
			this.$store.dispatch('Settings/setCurrentTitle', `${meta} - 特规通`);
		},

		setSelectInfo(info) {
			this.info = info;
		},

		init() {
			let curModule = null;
			let curGroup = this.$route.query.group;
			let id = this.$route.query.id;
			this.type = this.$route.query.type;
			switch (curGroup) {
				case '用户协议': {
					curModule = AgreeList;
					break;
				}
				case '功能介绍': {
					curModule = ProductList;
					break;
				}
				case '功能介绍_个人版': {
					curModule = PersonProductList;
					break;
				}
				case '关于我们': {
					curModule = AboutUsList;
					break;
				}
				case '用户协议': {
					curModule = LoginList;
					break;
				}
				case '在线问题反馈': {
					curModule = [];
					break;
				}
			}
			let { list } = curModule;
			this.group = curGroup;
			this.menus = list;
			this.$nextTick(() => {
				this.$refs.LeftSideDom.setSelect(id);
			});
			this.setSEOInfo(curGroup);
		}
	},
	created() {
		this.init();
	},
	watch: {
		$route(to, from) {
			let id = to.query.id;
			if (id != from.query.id) {
				this.init();
			}
		}
	}
};
</script>

<style lang="less" scoped>
.wrap-80 {
	width: 80%;
	// height: calc(100vh - 350px);
	margin: 0 auto;
	padding: 20px 0;
	display: flex !important;
	justify-content: space-between;
}
.bookshelf {
	border: 1px solid #e2e8f0;
}
.el-card__body,
.el-main {
	padding: 20px 0;
}
//媒体查询-pad
@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
	.wrap-80 {
		width: 96%;
	}
}
</style>
